<template>
  <form @submit='login'>

    <vs-input 
      name="email"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather" 
      placeholder="Email" 
      v-model="email"
      class="w-full"/>

    <vs-input
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        placeholder="Password"
        v-model="password"
        class="w-full mt-6" 
        @keyup.enter="login"/> 

    <div class="flex flex-wrap justify-between my-5">
        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Lembrar</vs-checkbox> -->
        <router-link class="text-danger" to="/forgotPassword">Esqueceu a senha?</router-link>
    </div>

    <!-- <vs-button color="danger" type="border" @click="register">Registrar</vs-button> -->
    <vs-button color="danger" class="float-right w-full mb-4" @click="login">ENTRAR</vs-button>
    
    <vs-divider class="mt-6"></vs-divider>

    <div class="text-danger text-sm text-center">Faça parte da revolução de restaurantes</div>
    <vs-button type="border" color="danger" class="mt-4 float-right w-full" style="opacity: 0.5"
      disabled>CRIAR MINHA CONTA GRÁTIS (Em breve)</vs-button>
    
  </form>
</template>

<script>
import firebase from '../../../firebase/firebase'
import 'firebase/auth'

export default {
  data() {
    return {
      email: "",
      password: "",
    }
  },
  created() {
    
  },
  methods: {
    async login () {
      this.$vs.loading()

      this.$store.dispatch('isNewUser', false);

      try {
        await firebase.auth().signInWithEmailAndPassword(this.email.trim(), this.password)
      } catch (err) {
        console.log(err);
        this.$error({
          title: 'Erro de login',
          content: 'Login ou senha incorretos!',
          okText: 'Fechar',
          okType: 'danger'
        })
      }
      this.$vs.loading.close();
    },
    register () {
      this.$router.push('/register').catch(() => {})
    },
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
